import { tableFromIPC, compressionRegistry, CompressionType } from "apache-arrow";
import * as lz4 from "lz4js";
const lz4Codec = {
    encode(data) {
        return lz4.compress(data);
    },
    decode(data) {
        return lz4.decompress(data);
    }
};
compressionRegistry.set(CompressionType.LZ4_FRAME, lz4Codec);
export function tableFromArrayBuffer(data) {
    return tableFromIPC(data);
}
export function toTypedArray(array) {
    if (array instanceof BigInt64Array || array instanceof BigUint64Array) {
        const output = new Array(array.length);
        for (let i = 0; i < array.length; i++) {
            output[i] = Number(array[i]);
        }
        return output;
    }
    return array;
}
